'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import { getItem } from '@alltrails/core/utils/localStorage';
import useUpsellContent from '../../hooks/useUpsellContent';
import { useAppSelector } from '../../utils/redux';

const PostAuthUpsellModal = dynamic(() => import('../GenericPostAuthUpsell/PostAuthUpsellModal'), {
  ssr: false
});

const snoozeDurationDays = 14 * 1000 * 60 * 60 * 24; // 14 days

export default function ReturningUserUpsell() {
  const user = useUser();
  const { isOpen, serverUpsellContent, setIsOpen } = useUpsellContent('Returning user page view', { delayOpen: true });
  const isInstallBannerOpen = useAppSelector(state => state.installBanner?.isOpen === true);

  useEffect(() => {
    // Prevent showing this upsell with apple redirect upsell
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('apple_oauth')) {
      return;
    }

    const lastDisplayTime = getItem<number>('post-auth-upsell');

    if (user && !isSubscriber(user) && ((lastDisplayTime && new Date().getTime() - lastDisplayTime >= snoozeDurationDays) || !lastDisplayTime)) {
      setIsOpen(true);
    }
    // we don't want to run this after sign up modal or google one tap updates the user which would show two upsells
  }, []);

  if (isOpen) {
    return (
      <PostAuthUpsellModal
        isFocusPaused={isInstallBannerOpen}
        isOpen={isOpen}
        onCloseRequest={() => {
          setIsOpen(false);
        }}
        serverUpsellContent={serverUpsellContent}
        upsellTrigger="Returning user page view"
      />
    );
  }

  return null;
}
